const LOCAL_STORAGE_KEY = 'visibleLists';

export const getVisibleListIds = (workspaceId: string): string[] => {
  try {
    const data = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
    return data[workspaceId] || [];
  } catch {
    return [];
  }
}

const setVisibleListIds = (workspaceId: string, listIds: string[]) => {
  const data = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
  data[workspaceId] = listIds;
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
}

export const addVisibleListId = (workspaceId: string, listId: string) => {
  const listIds = getVisibleListIds(workspaceId);
  if (!listIds.includes(listId)) {
    listIds.push(listId);
    setVisibleListIds(workspaceId, listIds);
  }
}

export const removeVisibleListId = (workspaceId: string, listId: string) => {
  const listIds = getVisibleListIds(workspaceId).filter(id => id !== listId);
  setVisibleListIds(workspaceId, listIds);
}
